module.exports = __webpack_public_path__ + "r-v3/img/icon-schedule-screenShare_white.58b45ba6.svg";